export interface IArticleStructuredData {
  '@context': string;
  '@type': string;
  datePublished?: string;
  dateModified?: string;
  headline?: string;
  image?: string | string[];
  author?: {
    '@type': string;
    name: string;
    url: string;
  }[];
}

export enum EventLocation {
  Place = 'Place',
  VirtualLocation = 'VirtualLocation',
}

export enum EventAttendanceMode {
  Online = 'OnlineEventAttendanceMode',
  Offline = 'OfflineEventAttendanceMode',
}

export interface IEventStructuredData {
  '@context': string;
  '@type': string;
  location: {
    '@type': EventLocation;
    url?: string;
    name?: string;
    address?: {
      '@type': string;
      name?: string;
    };
  };
  eventAttendanceMode: EventAttendanceMode;
  name?: string;
  startDate?: string;
  description?: string;
  endDate?: string;
  image?: string | string[];
  organizer?: {
    '@type'?: string;
    name?: string;
    url?: string;
  };
}

export interface IOrganizationStructuredData {
  '@context': string;
  '@type': 'Organization';
  url: string;
  sameAs: string[];
  logo: string;
  name: string;
  description: string;
  email: string;
  address: {
    '@type': 'PostalAddress';
    streetAddress: string;
    addressLocality: string;
    addressCountry: string;
    addressRegion: string;
    postalCode: string;
  };
}

export interface ISoftwareAppStructuredData {
  '@context': string;
  '@graph': Array<{
    '@type': 'SoftwareApplication';
    name: string;
    operatingSystem: string;
    applicationCategory: string;
    installUrl: string;
    aggregateRating: {
      '@type': 'AggregateRating';
      ratingValue: string;
      reviewCount: string;
    };
    offers: {
      '@type': 'Offer';
      price: string;
      priceCurrency: string;
    };
  }>;
}

export interface IFAQStructuredData {
  '@context': string;
  '@type': 'FAQPage';
  mainEntity: Array<{
    '@type': 'Question';
    name: string;
    acceptedAnswer: {
      '@type': 'Answer';
      text: string;
    };
  }>;
}
